const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138,
    height: 168,
    viewBox: "0 0 138 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 1222",
    transform: "translate(-126 -301)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rettangolo 1956",
    width: 97,
    height: 96,
    rx: 33,
    transform: "translate(147 301)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 789",
    d: "M14.673 7.354c.327-.4 1.489-1.208 4.018-1.881a33.434 33.434 0 0 1 8.325-.97 33.432 33.432 0 0 1 8.325.97c2.529.673 3.691 1.485 4.018 1.881-.006-.008 0 0 0 .01a6.314 6.314 0 0 1 .541 1.653 29.774 29.774 0 0 1 .55 4.73 108.1 108.1 0 0 1-.341 12.973c-.5 6.522-6.141 11.551-13.09 11.551s-12.591-5.029-13.09-11.551a108.105 108.105 0 0 1-.341-12.974 29.743 29.743 0 0 1 .55-4.73 6.316 6.316 0 0 1 .535-1.653c.005-.014.006-.016 0-.009zM11.2 4.487c4.943-5.987 26.688-5.987 31.63 0 .9 1.085 1.467 3.034 1.8 5.5 7.409 1.337 9.4 4.286 9.4 10.275 0 6.176-2.117 9.119-10.11 10.4a17.5 17.5 0 0 1-16.904 12.113A17.5 17.5 0 0 1 10.11 30.658C2.117 29.381 0 26.438 0 20.262c0-5.989 1.991-8.938 9.4-10.275.335-2.466.906-4.416 1.8-5.5zM9.042 14.654a13.5 13.5 0 0 0-2.145.66 3.2 3.2 0 0 0-1.831 1.4 7.757 7.757 0 0 0-.563 3.55 7.756 7.756 0 0 0 .563 3.55A3.2 3.2 0 0 0 6.9 25.21a14.221 14.221 0 0 0 2.456.729c-.272-3.816-.425-7.776-.314-11.285zm35.636 11.285a14.218 14.218 0 0 0 2.456-.729 3.2 3.2 0 0 0 1.831-1.4 7.758 7.758 0 0 0 .563-3.55 7.759 7.759 0 0 0-.563-3.55 3.2 3.2 0 0 0-1.831-1.4 13.487 13.487 0 0 0-2.145-.66c.111 3.513-.042 7.473-.311 11.289z",
    transform: "translate(168 321.984)",
    style: {
      fillRule: "evenodd",
      fill: "#04051d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 790",
    d: "M23.759 31.508H10.251a2.251 2.251 0 0 1 0-4.5h4.5v-6.757a2.251 2.251 0 1 1 4.5 0v6.754h4.5a2.251 2.251 0 0 1 0 4.5z",
    transform: "translate(178.01 344.507)",
    style: {
      fill: "#04051d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/Trophy.8e75155ea2589787a8f09ec252ce44da.svg";
export { ForwardRef as ReactComponent };